import React, { useState } from "react";

function App() {
  const [preview, setPreview] = useState(null);
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [image, setImage] = useState(null);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImage(file);
    setPreview(URL.createObjectURL(file));
    setResult(null);
  };

  const diseases = [
    {
      name: "Leaf Blight",
      hindi: "पत्ती झुलसा",
      status: "⚠️ Disease Detected",
      symptoms: "Yellow spots, brown edges, wilting leaves",
      treatment: "Apply copper-based fungicide. Remove affected leaves. Ensure proper drainage."
    },
    {
      name: "Powdery Mildew",
      hindi: "चूर्णिल फफूंदी",
      status: "⚠️ Disease Detected",
      symptoms: "White powdery coating on leaves",
      treatment: "Spray neem oil solution. Improve air circulation around plant."
    },
    {
      name: "Healthy Plant",
      hindi: "स्वस्थ पौधा",
      status: "✅ Plant is Healthy",
      symptoms: "No symptoms detected",
      treatment: "Continue regular watering and fertilization."
    }
  ];

  const analyzeImage = () => {
    if (!image) return alert("Pehle image select karo!");
    setLoading(true);
    setResult(null);
    setTimeout(() => {
      const random = diseases[Math.floor(Math.random() * diseases.length)];
      setResult(random);
      setLoading(false);
    }, 2000);
  };

  return (
    <div style={{ minHeight: "100vh", background: "linear-gradient(135deg, #1a4a1a, #2d7a2d)", fontFamily: "Arial", color: "white" }}>
      <div style={{ textAlign: "center", padding: "40px 20px" }}>
        <h1 style={{ fontSize: "3rem" }}>🌾 FarmSense</h1>
        <p style={{ fontSize: "1.2rem", opacity: 0.8 }}>AI-Powered Crop Disease Detector</p>
        <p style={{ opacity: 0.6 }}>Upload a plant photo — Get instant diagnosis</p>
      </div>
      <div style={{ maxWidth: "600px", margin: "0 auto", padding: "20px" }}>
        <div style={{ background: "rgba(255,255,255,0.1)", borderRadius: "20px", padding: "30px", textAlign: "center" }}>
          <input type="file" accept="image/*" onChange={handleImageChange} style={{ display: "none" }} id="imageInput" />
          <label htmlFor="imageInput" style={{ cursor: "pointer", display: "block", padding: "20px", border: "2px dashed rgba(255,255,255,0.5)", borderRadius: "15px", marginBottom: "20px" }}>
            {preview ? (
              <img src={preview} alt="plant" style={{ maxWidth: "100%", maxHeight: "300px", borderRadius: "10px" }} />
            ) : (
              <div>
                <div style={{ fontSize: "4rem" }}>📷</div>
                <p>Click to upload plant image</p>
                <p style={{ opacity: 0.6, fontSize: "0.9rem" }}>JPG, PNG supported</p>
              </div>
            )}
          </label>
          <button onClick={analyzeImage} disabled={loading} style={{ background: loading ? "#666" : "#4CAF50", color: "white", border: "none", padding: "15px 40px", borderRadius: "30px", fontSize: "1.1rem", cursor: loading ? "not-allowed" : "pointer", width: "100%" }}>
            {loading ? "🔍 Analyzing..." : "🔍 Analyze Plant"}
          </button>
        </div>
        {result && (
          <div style={{ background: "rgba(255,255,255,0.15)", borderRadius: "20px", padding: "25px", marginTop: "20px" }}>
            <h3>📋 Analysis Result</h3>
            <h2>{result.status}</h2>
            <p><b>Disease:</b> {result.name} ({result.hindi})</p>
            <p><b>Symptoms:</b> {result.symptoms}</p>
            <p><b>Treatment:</b> {result.treatment}</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default App;